import _ from 'lodash'
import SecureLS from 'secure-ls'
import config from './_config'
import { storageAvailable } from '../_utils'

export let LS = new SecureLS({ encodingType: 'aes', isCompression: false })

// Local Storage Versioning
const saveVersionToStorage = (version) => {
  if (!storageAvailable) return
  LS.set('mainAppVersion', version)
}
const getVersionFromStorage = () => {
  if (!storageAvailable) return
  const version = LS.get('mainAppVersion')
  return version
}
export const handleAppVersioning = () => {
  if (!storageAvailable) return

  const storedAppVersion = getVersionFromStorage()
  const currentVersion = config.appVersion

  if (storedAppVersion != currentVersion) {
    LS.removeAll()
    saveVersionToStorage(currentVersion)

    console.info('Updating app version to: ' + currentVersion)
  }
}
// PRODUCTS
export const saveProductsToStorage = (store) => {
  if (!storageAvailable) return
  let products = JSON.stringify(store.getState().products.list)
  store.subscribe(() => {
    let oldProducts = products
    products = JSON.stringify(store.getState().products.list)
    if (products !== oldProducts) {
      // localStorage.setItem('products', JSON.stringify(currentValue));
      // console.log('PRODUCTS udpated');
      LS.set('products', JSON.parse(products))
    }
  })
}
export const getProductsFromStorage = (store) => {
  if (!storageAvailable) return
  // const products = localStorage.getItem('products');
  const products = LS.get('products')
  if (!products) return
  store.dispatch({
    type: 'SET_PRODUCTS_LIST',
    list: _.keyBy(products, 'id'),
  })
}
